export default __webpack_public_path__ + "static/media/vx-form-logo.27f6139a.svg";